"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmOrderOrderInnerDetailsToJSON = exports.ConfirmOrderOrderInnerDetailsFromJSONTyped = exports.ConfirmOrderOrderInnerDetailsFromJSON = exports.instanceOfConfirmOrderOrderInnerDetails = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the ConfirmOrderOrderInnerDetails interface.
 */
function instanceOfConfirmOrderOrderInnerDetails(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfConfirmOrderOrderInnerDetails = instanceOfConfirmOrderOrderInnerDetails;
function ConfirmOrderOrderInnerDetailsFromJSON(json) {
    return ConfirmOrderOrderInnerDetailsFromJSONTyped(json, false);
}
exports.ConfirmOrderOrderInnerDetailsFromJSON = ConfirmOrderOrderInnerDetailsFromJSON;
function ConfirmOrderOrderInnerDetailsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'sizes': !(0, runtime_1.exists)(json, 'sizes') ? undefined : json['sizes'],
        'color': !(0, runtime_1.exists)(json, 'color') ? undefined : json['color'],
    };
}
exports.ConfirmOrderOrderInnerDetailsFromJSONTyped = ConfirmOrderOrderInnerDetailsFromJSONTyped;
function ConfirmOrderOrderInnerDetailsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'sizes': value.sizes,
        'color': value.color,
    };
}
exports.ConfirmOrderOrderInnerDetailsToJSON = ConfirmOrderOrderInnerDetailsToJSON;
